import {Entity} from '@s-ui/domain'

export default class ProductEntity extends Entity {
  /**
   * @param {Object} product
   * @param {String} product.id
   * @param {String} product.name
   * @param {String} product.title
   * @param {String} product.description
   * @param {String} product.image
   * @param {Bool} product.recommended
   * @param {Object} product.price
   * @param {Number} product.price.value
   * @param {Number} product.price.amountLabelValue
   * @param {String} product.price.currency
   * @param {Object} product.tax
   * @param {String} product.tax.type
   * @param {Number} product.tax.percentage
   * @param {Number} product.tax.amount
   * @param {Bool} product.isActive
   * @param {Number} product.visibility // Visibility refers to the degree of improvement in product visibility
   * @param {Number} product.duration // Duration refers to the maximum time the product will be active
   * */

  getProduct = () => {
    return {
      id: this._id,
      name: this._name,
      title: this._title,
      discount: this._discount,
      description: this._description,
      image: this._image,
      recommended: this._recommended,
      price: this._price,
      priceBeforeDiscount: this._priceBeforeDiscount,
      tax: this._tax,
      isActive: this._isActive,
      visibility: this._visibility,
      duration: this._duration
    }
  }

  static validate({InvalidProductErrorFactory, ...rest}) {
    /**
     * @return {Bool}
     * Checks if one of the parameters defined in the factory has a falsy value.
     * The exception of boolean values is included, since it can be that a false value comes.
     * The previous condition would discard it, behavior that we don't want.
     * */
    const hasError = Object.values(rest).some(value => !value && typeof value !== 'boolean')

    if (hasError) throw InvalidProductErrorFactory()
  }
}
